import http from "./HttpService";

var endpoint = `/lookup/`;

const getTitles = async () => {
  const response = await http.get(`${endpoint}titles`);
  return response;
};

const getRaces = async () => {
  const response = await http.get(`${endpoint}races`);
  return response;
};

const getGenders = async () => {
  const response = await http.get(`${endpoint}genders`);
  return response;
};

const getProvinces = async () => {
  const response = await http.get(`${endpoint}south-africa/provinces`);
  return response;
};

const getProvincesDistrictTowns = async () => {
  const response = await http.get(`${endpoint}south-africa/province-district-towns`);
  return response;
};

const getProvincesDistrict = async () => {
  const response = await http.get(`${endpoint}south-africa/provinces-districts`);
  return response;
};

const getEventTypes = async () => {
  const response = await http.get(`${endpoint}event/venue/types`);
  return response;
};

const getEventGroups = async () => {
  const response = await http.get(`${endpoint}event/groups`);
  return response;
};

const getFaqModule = async () => {
  const response = await http.get(`${endpoint}system-modules`);
  return response;
};

const getLanguges = async () => {
  const response = await http.get(`${endpoint}south-africa/languages`);
  return response;
};

const getScienceFields = async () => {
  const response = await http.get(`${endpoint}citizen/science/fields`);
  return response;
};

const getScienceDomains = async (fieldId) => {
  const response = await http.get(`${endpoint}citizen/science/domains/${fieldId}`);
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getTitles,
  getRaces,
  getGenders,
  getProvinces,
  getEventTypes,
  getEventGroups,
  getLanguges,
  getFaqModule,
 getProvincesDistrictTowns,
 getProvincesDistrict,
 getScienceFields,
 getScienceDomains
};
